<template>
  <div class="punch_clock">
    <head-top head-title="打卡记录" go-back="true"></head-top>
    <div class="punch">
      <div class="list_box">
        <h3>姓名：<span>{{detail.name}}</span></h3>
        <div class="box_single">
          <!--上班-->
          <div class="basics" v-if="detail.first_time || detail.first_address">
            <div class="bas_li">
              <div class="blue_line"></div>
              <img src="../images/tongji_time_icon@2x.png" alt="">
              <span>上班时间：</span>{{detail.first_time}}
            </div>
            <div class="bas_li">
              <div class="blue_line2"></div>
              <img src="../images/tongji_place_icon@2x.png" alt="">
              <span>上班地点：</span>
              <div class="add_text">{{detail.first_address}}
              </div>
            </div>
          </div>
          <!--下班-->
          <div class="basics" v-if="detail.fourth_address || detail.fourth_time">
            <div class="bas_li">
              <div class="blue_line"></div>
              <img src="../images/tongji_time_icon@2x.png" alt="">
              <span>下班时间：</span>{{detail.fourth_time}}
            </div>
            <div class="bas_li">
              <div class="blue_line2"></div>
              <img src="../images/tongji_place_icon@2x.png" alt="">
              <span>下班地点：</span>
              <div class="add_text">{{detail.fourth_address}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '../../../components/header/Header'
  import {punchList} from '../../../api/my'
  import {Indicator} from 'mint-ui'

  export default {
    name: 'PunchRecord',
    data () {
      return {
        detail: {}
      }
    },
    created () {
      this._punchList()
    },
    methods: {
      _punchList() {
        Indicator.open({
          text: '..加载中..',
          spinnerType: 'fading-circle'
        })
        punchList(this.$route.params.id).then(res => {
          // console.log(res)
          if (res.code === 200) {
            Indicator.close()
            this.detail = res.data
          }
        })
      }
    },
    components: {
      headTop
    }
  }
</script>

<style lang="scss" scoped>
  .punch_clock{
    padding-top: 60px;
    .punch{
      width: 100%;
      .list_box{
        h3{
          font-size: 17px;
          color: #333333;
          padding: 10px;
          background: #f2f2f2;
          font-weight: normal;
          span{
            color: #666666;
          }
        }
        .box_single{
          padding: 10px;
          /*border-bottom: 10px solid #f2f2f2;*/
          .basics{
            border-radius: 5px;
            border: 1px solid #f2f2f2;
            box-shadow: 3px 2px 5px #f2f2f2;
            padding: 10px 10px;
            margin-top: 10px;
            .bas_li{
              font-size: 13px;
              color: #666666;
              margin-top: 10px;
              display: inline-flex;
              align-items: center;
              .blue_line{
                width: 5px;
                height: 20px;
                background: #0C7AD9;
                border-radius: 5px;
                margin-right: 5px;
              }
              .blue_line2{
                width: 5px;
                height: 20px;
                /*background: #0C7AD9;*/
                border-radius: 5px;
                margin-right: 5px;
              }
              img{
                width: 15px;
                margin-right: 5px;
              }
              span{
                color: #333333;
              }
              .add_text{
                color: #333333;
                width: 65%;
                text-align: left;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my/runBuild/PunchRecord.vue